import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoadingState {
  isWorkspaceDataLoading: boolean;
}

const initialState: LoadingState = {
  isWorkspaceDataLoading: false,
};

export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setWorkspaceDataLoading: (state, action: PayloadAction<boolean>) => {
      state.isWorkspaceDataLoading = action.payload;
    },
  },
});

export const { setWorkspaceDataLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
